/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Toast, Dialog } from '@hb/coffee';
import { Component, Prop, Mixins } from 'vue-property-decorator';
import {
  CouponPo, stateCodeEnum, stateCodeEnumName, UseSceneEnum,
} from '@/api/coupon/types';
import { agreementService } from '@/service/confirm-agreements';
import { RouterV2Enum } from '@/router/router-names';
import FinanceBusiness from '@/mixins/finance-business';
import useDispatchProcess from '@/hooks/useDispatchProcess';

const style = require('./index.module.scss');


@Component({ name: 'CouponUsing' })
export default class CouponUsing extends Mixins(
  FinanceBusiness,
) {
  @Prop({ default: false })
  private isOverTime!: boolean;

  @Prop()
  private couponList!: CouponPo[];

  private mounted() {
    agreementService.preloadAgreementsData();
  }

  private btnArrow(index: number) {
    this.couponList[index].isExtend = !this.couponList[index].isExtend;
  }

  private subString(str: string, numIndex: number, numMax: number) {
    const subStr = str;
    return subStr.substr(numIndex, numMax);
  }

  private availableUbt(value: string) {
    this.$ubtPageButtonNew('finance_myCoupon_inEffect_apply', {
      flagType: 'hasAmount',
      falgValue: '001',
      useScene: value,
    });
  }

  private use(item: CouponPo) {
    const {
      stateCode, availableProductId, couponId, externalCouponId = '', useScene,
    } = item;
    const { applyProcessDispatch } = useDispatchProcess();
    // 可使用，去提现页, 且有渠道 id
    if (
      stateCode === stateCodeEnum.AVAILABLE && useScene === UseSceneEnum.LEND && availableProductId
    ) {
      this.availableUbt(UseSceneEnum.LEND);
      const query = {
        commodityId: availableProductId,
        couponId,
        externalCouponId,
      };
      applyProcessDispatch(query);
    }

    // 可使用，使用类型为还款，去还款账单页
    if (stateCode === stateCodeEnum.AVAILABLE && useScene === UseSceneEnum.REPAY) {
      this.availableUbt(UseSceneEnum.REPAY);
      this.$router.push({
        path: RouterV2Enum.myBill,
      });
    }

    // 待确认，去授信流程
    if (stateCode === stateCodeEnum.CONFIRM) {
      this.confirmDialog(item);
    }

    if (stateCode === stateCodeEnum.UNEFFECTIVE) {
      this.$ubtPageButton('finance_myCoupon_inEffect_comingSoon');
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      Toast('生效时间后可用');
    }
  }

  // 显示用户姓名验证不通过确认弹窗，引导用户修改用户姓名
  private confirmDialog(item: CouponPo) {
    this.$ubtModuleExpose('finance_myCoupon_inEffect_apply_unlock');
    Dialog.confirm({
      title: '请解锁后使用',
      message: item.rejectRuleDesc,
      cancelButtonText: '取消',
      confirmButtonText: '去解锁',
      closeable: false,
    })
      .then(() => {
        if (item.rejectRule) {
          this.$ubtPageButton('finance_myCoupon_inEffect_apply_unlock_go', 'unlockLimitReason', item.rejectRule);
        }
        this.onApplyCredit('finance_myCoupon_inEffect_apply_unlock_go', 'hasAmount', '002');
      })
      .catch(() => {
        this.$ubtPageButton('finance_myCoupon_inEffect_apply_unlock_cancel');
      });
  }


  private getCouponName(amount: string): unknown {
    // 有小数
    if (amount.indexOf('.') > -1) {
      return (
        <div>
          {amount.split('.')[0]}
          {/* amount是带单位的字符串，需要将单位&小数区分开设置样式 */}
          <span class={style.text1}>.{amount.split('.')[1].slice(0, -1)}</span>
          <span class={style.text2}>{amount.split('.')[1].slice(-1)}</span>
        </div>
      );
    }
    return (
      <div>
        {amount.slice(0, -1)}
        <span class={style.text2}>{amount.slice(-1)}</span>
      </div>
    );
  }

  private renderCard(item: CouponPo, index: number) {
    return (
      <div class={style.main}>
        <div class={style.img}>
          <div
            class={style.left}
            style={!this.isOverTime ? { color: '#879099' } : ''}
          >
            {this.getCouponName(item.amount)}
          </div>
          <div
            class={style.right}
            style={!this.isOverTime ? { color: '#879099' } : ''}
          >
            <div
              class={style.tip}
              style={
                !this.isOverTime ? { color: '#879099' } : ''
              }
            >
              {item.couponName}
            </div>
            <div class={style.time}>
              {this.subString(item.effectiveStartDate, 0, 10).replace(/-/g, '.')} -{' '}
              {this.subString(item.effectiveEndDate, 0, 10).replace(/-/g, '.')}
            </div>
          </div>
          <div
            class={[
              style.btn,
              style[item.stateCode],
            ]}
            onClick={this.isOverTime ? () => this.use(item) : () => null}
          >
            {stateCodeEnumName[item.stateCode]}
          </div>
        </div>
        <div class={style.text} onClick={() => this.btnArrow(index)}>
          <div
            class={!this.couponList[index].isExtend ? style.elisp : style.normal}
          >
            {this.getComments(item)}
          </div>
          {this.showArrow(item) && (
            <div
              style={
                this.couponList[index].isExtend
                  ? { transform: 'rotate(180deg)', transition: 'all 0.3s' }
                  : { transform: 'rotate(0deg)', transition: 'all 0.3s' }
              }
              class={style.icon}
            >
              <div class={style.arrow}></div>
            </div>
          )}

        </div>
      </div>
    );
  }


  private getComments(item: CouponPo): unknown {
    if (!item.comments.includes('\n')) {
      return item.comments;
    }

    return !item.isExtend ? item.comments : item.comments.split(/\n/g).map((comment) => <p>{comment}</p>);
  }

  private showArrow(item: CouponPo): boolean {
    if (item.comments.includes('\n') || item.comments.length > 26) {
      return true;
    }
    return false;
  }

  private render() {
    return (
      <div class={style.CouponUsing}>
        {this.couponList.length > 0
          && this.couponList.map((item, index) => this.renderCard(item, index))}
        <div class={style.nomore}>没有更多了~</div>
      </div>
    );
  }
}
